import { AscCustomAlertsAlertContainer } from './containers'
import Index from './Index'

import { role } from '@/utilities/userRoles'

const customAlertsRouter = {
  path: '/user',
  component: Index,
  meta: {},
  children: [
    {
      path: '/custom-analytics/:alertType(acmf|fullflight|advanced-acmf|advanced-fullflight|advanced-dplf)/:alertId([0-9a-fA-F-]{36})?',
      name: 'Custom Analytic',
      component: AscCustomAlertsAlertContainer,
      meta: {
        requiresRole: [role.airlineUser, role.acmfUser],
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Custom Analytics',
            to: '/custom-analytics',
          },
          {
            text: route =>
              ` ${
                route.params.alertType === 'fullflight'
                  ? 'Set a Full Flight Data Analytic'
                  : route.params.alertType === 'advanced-acmf'
                  ? 'Set an Advanced Logic ACMF Data Analytic'
                  : route.params.alertType === 'advanced-fullflight'
                  ? 'Set an Advanced Logic Full Flight Data Analytic'
                  : route.params.alertType === 'advanced-dplf'
                  ? 'Set an Advanced Logic DPLF Data Analytic'
                  : 'Set an ACMF Data Analytic'
              }`,
          },
        ],
      },
      props: route => ({
        alertId: isNaN(route.params.alertId) ? 0 : Number(route.params.alertId),
        alertType: route.params.alertType,
        buildData: route.params.buildData,
      }),
      children: [],
    },
  ],
}

export default customAlertsRouter
